import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconOldJoystick: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="old-joystick, gamepad, gaming, control"><path d="M12 3C13.933 3 15.5 4.567 15.5 6.5C15.5 8.17545 14.3224 9.57452 12.75 9.91797V14H16.5V11.75C16.5 11.3358 16.8358 11 17.25 11C17.6642 11 18 11.3358 18 11.75V14H19.25C20.2165 14 21 14.7835 21 15.75V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V15.75C3 14.7835 3.7835 14 4.75 14H11.25V9.91797C9.67756 9.57452 8.5 8.17545 8.5 6.5C8.5 4.567 10.067 3 12 3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconOldJoystick;
